module.exports = __webpack_public_path__ + "img/interview.c215817.png";